;(function (scope) {
  function isNumber(value) {
    if (isNaN(parseInt(value)) || value === '') {
      return false;
    }

    return true;
  }

  function Media() {
    this.browsing = false;
    this.instances = [];
    this.past_browse = false;
    this.last_browse = false;
    this.$dom = null;
    this.ajax = null;
    this.$activeElement = null;
    this.settings = null;
    this.currentCallback = null;
    this.currentSettings = null;
    this.$container = null;

    this.ajax_path = (window.location.href.indexOf('/build') !== -1 ? window.location.href : '/media/api/call');

    if (typeof window.UI !== 'undefined' && typeof window.UI.initCallbacks !== 'undefined') {
      window.UI.initCallbacks.push(this.reload.bind(this));
    }

    this.translations = null;
    this.translationsLoading = false;
    this.translationsCallbacks = [];

    this.callbacks = {};

    this.crop_options = {};
    this.croppr = null;
  }

  Media.prototype.on = function (event, callback) {
    if (typeof this.callbacks[event] === 'undefined') {
      this.callbacks[event] = [];
    }

    this.callbacks[event].push(callback);
  };

  Media.prototype.emit = function (event) {
    if (typeof this.callbacks[event] !== 'undefined') {
      for (var fn in this.callbacks[event]) {
        this.callbacks[event][fn]();
      }
    }
  };

  Media.prototype.getTranslations = function (fn) {
    if (this.translations !== null) {
      fn(this.translations);
      return;
    }

    this.translationsCallbacks.push(fn);

    if (!this.translationsLoading) {
      this.translationsLoading = true;

      window.Lang.translate(function (translation) {
        this.translations = translation;

        if (this.translationsCallbacks.length > 0) {
          for (var callback in this.translationsCallbacks) {
            this.translationsCallbacks[callback](this.translations);
          }
        }

        this.translationsCallbacks = null;
        this.translationsLoading = false;
      }.bind(this), this.getTranslationObject());
    }
  };

  Media.prototype.getTranslationObject = function () {
    return {
      'download': 'Download',
      'with_the_selected_files': 'With the selected files',
      'delete': 'Delete',
      'save': 'Save',
      'upload_files': 'Upload file(s)',
      'create_folder': 'Create folder',
      'open_folder': 'Open folder',
      'no_files_found': 'No files found',
      'medialibrary': 'Medialibrary',
      'drag_your_files_here': 'Drag your files here',
      'or_click_here_and_choose_them': 'Or click here & choose them',
      'upload_in_folder': 'Upload in folder',
      'select_folder': 'Select folder',
      'cancel': 'Cancel',
      'create_new_folder': 'Create new folder',
      'name': 'Name',
      'create_in_folder': 'Create in folder',
      'delete_confirm_title': 'Are you sure?',
      'delete_confirm_file_desc': 'Are you sure you want to delete this file(s)? This can not be undone.',
      'delete_confirm_folder_desc': 'Are you sure you want to delete this folder(s)? This can not be undone.',
      'path': 'Path',
      'example': 'Example',
      'copy_to_clipboard': 'Copy to clipboard',
      'lock_it': 'Yes, lock it',
      'unlock_it': 'Yes, unlock it',
      'lock_folder': 'Lock folder',
      'unlock_folder': 'Unlock folder',
      'lock_confirm_title': 'Are you sure?',
      'lock_confirm_folder_desc': 'Are you sure you want to lock this folder?',
      'unlock_confirm_folder_desc': 'Are you sure you want to unlock this folder?',
      'archive': 'Archive',
      'archive_confirm_title': 'Are you sure?',
      'archive_confirm_file_desc': 'Are you sure you want to archive this file(s)/folder(s)?',
      'archive_button_yes': 'Yes, archive them',
      'archive_dropdown': 'Archive',
      'unarchive': 'Unarchive',
      'unarchive_confirm_title': 'Are you sure?',
      'unarchive_confirm_file_desc': 'Are you sure you want to unarchive this file(s)/folder(s)?',
      'unarchive_button_yes': 'Yes, unarchive them',
      'crop': 'Crop',
      'crop_confirm_title': 'Are you sure?',
      'crop_confirm_desc': 'Are you sure you want to crop this image? This will create a new file.',
      'crop_it': 'Yes, crop it',
      'crop_dimentions_title': 'Selection value',
      'crop_enable': 'Enable',
      'crop_size_title': 'Size',
      'crop_dimentions_width': 'Width',
      'crop_dimentions_height': 'Height'
    };
  };

  Media.prototype.add = function(selector, type, extensions, callback, open_folder, tmp_file) {
    this.instances.push({
      selector: selector,
      type: type,
      extensions: extensions,
      callback: callback,
      open_folder: open_folder,
      tmp_file: tmp_file,
    });
  };

  Media.prototype.reload = function() {
    if (this.instances.length > 0) {
      for (var i = 0, len = this.instances.length; i < len; i++) {
        this.reloadItem(this.instances[i]);
      }
    }

    var $viewer = $('.medialibrary:not(.medialibrary--popup)');

    if ($viewer.length > 0) {
      this.$activeElement = null;
      this.last_browse = false;
      this.$container = $viewer;

      this.getTranslations(function () {
        this.browse(this.base_path);
      }.bind(this));
    }
  };

  Media.prototype.inIframe = function() {
    try {
      return window.self !== window.top;
    }
    catch (e) {
      return true;
    }
  };

  Media.prototype.reloadItem = function(item) {
    $(item.selector).unbind('click').bind('click', {
      selector: item.selector,
      type: item.type,
      extensions: item.extensions,
      instanceKey: this.instances.indexOf(item),
      open_folder: item.open_folder,
      tmp_file: item.tmp_file
    }, this.itemClick.bind(this));
  };

  Media.prototype.itemClick = function(e, isFromIframe) {
    isFromIframe = (typeof isFromIframe !== 'undefined' ? isFromIframe : false);

    e.preventDefault();

    if (this.inIframe()) {
      if (typeof window.top.mediaApiService !== 'undefined') {
        window.top.mediaApiService.browse(function (path, type) {
          this.instances[e.data.instanceKey].callback(path, type, $(e.target));
        }.bind(this));
      }
      else {
        scope.top.Media.currentCallback = this.instances[e.data.instanceKey].callback;
        scope.top.Media.itemClick(e, true);
      }

      return;
    }

    if (!isFromIframe) {
      this.currentCallback = this.instances[e.data.instanceKey].callback;
    }

    this.$activeElement = $(e.target);

    if (e.data.open_folder) {
      this.past_browse = e.data.open_folder;
    }

    this.last_browse = false;

    if (this.past_browse && this.past_browse != this.base_path) {
      var
        path = this.past_browse,
        pathArr = path.split('/');

      pathArr.splice(-1, 1);

      this.last_browse = pathArr.join('/');
    }

    this.getTranslations(function () {
      this.browse((this.past_browse || this.base_path), e.data);
      //this.browse(this.base_path, e.data);
    }.bind(this));
  };


  Media.prototype.archive_refresh = function() {
    var archive_list = $('.toolbar--medialibrary .button--dropdown-archive+ul'), output = '';

    archive_list.prev().addClass('button--disabled');

    if (this.past_browse == this.base_path) {
      $.ajax({
        type: 'POST',
        dataType: 'json',
        data: {
          media: 1,
          action: 'get_archives',
          path: this.base_path
        },
        url: this.ajax_path,
        success: function (data) {
          if (this.$dom.find('.tile .checkbox input:checked').length > 0) {
            if (data.info) {
              for (var i in data.info) {
                output += '<li class="dropdown__item">' +
                  '<a href="#" class="dropdown__link dropdown__link--archive" data-archive="' + data.info[i] + '">' +
                    '<i class="dropdown__icon fa fa-folder-o"></i> ' + data.info[i] +
                  '</a>' +
                '</li>';
              }
            }

            if (output != '') {
              archive_list.html(output);
              archive_list.prev().removeClass('button--disabled');
            }
          }
        }.bind(this)
      });
    }
    else {
      archive_list.html(output);
    }
  };


  Media.prototype.build = function() {
    var browse = [
      '<div class="toolbar toolbar--medialibrary">',
        '<div class="toolbar__item">',
          '<span class="button button--disabled button--dropdown-trigger button--dropdown-archive">' + this.translations.archive_dropdown + ' <span class="button__icon button__icon--right fa fa-caret-down"></span></span>',
          '<ul class="dropdown dropdown--dark dropdown--marked-options"></ul>',
        '</div>',
        '',
        '<div class="toolbar__item">',
          '<span class="button button--disabled button--dropdown-trigger button--dropdown-action">' + this.translations.with_the_selected_files + ' <span class="button__icon button__icon--right fa fa-caret-down"></span></span>',
          '<ul class="dropdown dropdown--dark dropdown--marked-options">',
            '<li class="dropdown__item">',
              '<a data-href="#" class="dropdown__link dropdown__link--download"><i class="dropdown__icon fa fa-download"></i> ' + this.translations.download + '</a>',
            '</li>',
            '<li class="dropdown__item">',
              '<a href="#" class="dropdown__link dropdown__link--delete"><i class="dropdown__icon fa fa-trash-o"></i> ' + this.translations.delete + '</a>',
            '</li>',
            '<li class="dropdown__item">',
              '<a href="#" class="dropdown__link dropdown__link--unarchive"><i class="dropdown__icon fa fa-folder-open-o"></i> ' + this.translations.unarchive + '</a>',
            '</li>',
          '</ul>',
        '</div>',
        '',
        '<div class="toolbar__item">',
          '<span class="button button--upload">' + this.translations.upload_files + '</span>',
        '</div>',
        '',
        '<div class="toolbar__item">',
          '<span class="button button--create-folder">' + this.translations.create_folder + '</span>',
        '</div>',
      '</div>',
      '<div class="medialibrary__list"></div>',
      '<div class="medialibrary__message">',
        '<i class="medialibrary__message-icon fa fa-camera"></i>',
        'No files found',
      '</div>',
    ].join('');

    if (this.$container) {
      this.$dom = this.$container;

      $(this.$container).append(browse);
    }
    else {
      var $popup = $([
        '<div class="popup popup--browse" id="browse-media-select">',
          '<span class="popup__close"></span>',
           '<div class="popup__content">',
             '<h4 class="popup__title">' + this.translations.medialibrary + '</h4>',
             '<div class="medialibrary medialibrary--popup">',
              browse,
            '</div>',
          '</div>',
        '</div>',
      ].join(''));

      this.$dom = $popup;

      $(document.body).append($popup);

      $popup.find('.popup__close, .button--cancel').unbind('click').bind('click', function (e) {
        $popup.removeClass('popup--active');

        window.Media.emit('popup:close');

        return false;
      });
    }

    $(document.body).append([
      '<div class="popup popup--upload-file">',
        '<span class="popup__close"></span>',
        '<div class="popup__content">',
          '<h4 class="popup__title">' + this.translations.upload_files + '</h4>',
          '<form action="/" class="form form--ajax form--upload">',
            '<div class="form-element form-element--upload">',
              '<div class="dz-message">',
                '<div class="dz-message-inner">',
                  this.translations.drag_your_files_here,
                  '<span class="dz-submessage">' + this.translations.or_click_here_and_choose_them + '</span>',
                '</div>',
              '</div>',
            '</div>',
            '<div class="form-element form-element--select form-element--folder">',
              '<label class="form-element__label">' + this.translations.upload_in_folder + '</label>',
              '<div class="form-element__controls">',
                '<select class="form-element__input form-element__input--select" name="upload[folder]">',
                  '<option value="" selected="selected">' + this.translations.select_folder + '</option>',
                '</select>',
              '</div>',
            '</div>',
            '<div class="form-actions">',
              '<input type="button" class="button button--action button--cancel" value="' + this.translations.cancel + '" />',
              '<input type="submit" class="button button--submit button--action" value="' + this.translations.upload_files + '" />',
            '</div>',
          '</form>',
        '</div>',
      '</div>',
      '<div class="popup popup--create-folder">',
        '<span class="popup__close"></span>',
        '<div class="popup__content">',
          '<h4 class="popup__title">' + this.translations.create_new_folder + '</h4>',
          '<form action="#" class="form form--ajax form--upload">',
            '<div class="form-element form-element--text form-element--name">',
              '<label class="form-element__label">' + this.translations.name + '</label>',
              '<div class="form-element__controls">',
                '<input type="text" class="form-element__input form-element__input--text" name="file_create[name]" />',
              '</div>',
            '</div>',
            '<div class="form-element form-element--select form-element--folder">',
              '<label class="form-element__label">' + this.translations.create_in_folder + '</label>',
              '<div class="form-element__controls">',
                '<select class="form-element__input form-element__input--select" name="file_create[folder]">',
                  '<option value="" selected="selected">' + this.translations.select_folder + '</option>',
                '</select>',
              '</div>',
            '</div>',
            '<div class="form-actions">',
              '<input type="button" class="button button--action button--cancel" value="' + this.translations.cancel + '" />',
              '<input type="submit" class="button button--submit button--action" value="' + this.translations.create_folder + '" />',
            '</div>',
          '</form>',
        '</div>',
      '</div>',
      '<div class="popup popup--preview">',
        '<span class="popup__close"></span>',
        '<div class="popup__content">',
          '<h4 class="popup__title"></h4>',
          '<div class="popup__image-wrapper"></div>',
        '</div>',
      '</div>',
      '<div class="popup popup--crop">',
        '<span class="popup__close"></span>',
        '<div class="popup__content popup__content--center">',
          '<div class="popup__crop-wrapper">',
            '<div class="media-crop-image"></div>',
            '<div class="media-crop">',
              '<div class="media-crop__selection">',
                '<h3 class="media-crop__selection-title">' + window.Media.translations.crop_dimentions_title + '</h3><span class="media-crop__selection-item crop--val-x">',
                  '<strong>x</strong>-</span><span class="media-crop__selection-item crop--val-y"><strong>y</strong>-</span>',
                  '<span class="media-crop__selection-item crop--val-w"><strong>' + window.Media.translations.crop_dimentions_width + '</strong>-</span>',
                  '<span class="media-crop__selection-item crop--val-h"><strong>' + window.Media.translations.crop_dimentions_height + '</strong>-</span>',
                '</div>',
                '<div class="form-element form-element--checkbox clearfix">',
                  '<label class="form-element__label">' + window.Media.translations.crop_size_title + '</label>',
                  '<div class="form-element__input-wrapper form-element__input-wrapper--checkbox"><input class="form-element__input form-element__input--checkbox" type="checkbox" id="crop-size-checkbox"><label class="form-element__label form-element__label--checkbox" for="crop-size-checkbox">' + window.Media.translations.crop_enable + '</label></div>',
                '</div>',
                '<div class="media-crop__grouped">',
                  '<div class="form-element form-element--text"><div class="form-element__controls">',
                     '<input class="form-element__input form-element__input--text form-element__input--icon crop--val-size-w" type="text" value="100" disabled="disabled"><span class="icon icon--left">W</span>',
                  '</div></div>',
                  '<div class="form-element form-element--text"><div class="form-element__controls">',
                    '<input class="form-element__input form-element__input--text form-element__input--icon crop--val-size-h" type="text" value="100" disabled="disabled"><span class="icon icon--left">H</span>',
                  '</div></div>',
                  '<div class="form-element form-element--select"><div class="form-element__controls">',
                    '<select disabled readonly><option>px</option></select>',
                  '</div>',
                '</div></div>',
              '</div>',
            '</div>',
            '<div class="form-actions form-actions--crop"><a class="button button--crop-save">' + window.Media.translations.save + '</a></div>',
          '</div>',
        '</div>',
      '</div>'
    ].join(''));

    $('.popup__crop-wrapper select').select2({minimumResultsForSearch: -1, dropdownAutoWidth : true});

    this.registerBaseEvents();
  };

  /**
   * Creates the output of the temporary files upload form
   * and registers its events.
   */
  Media.prototype.build_tmp_upload = function() {
    var popup = $('.popup--upload-tmp-file');

    if (popup.length == 0) {
      popup = $([
        '<div class="popup popup--upload-tmp-file">',
          '<span class="popup__close"></span>',
          '<div class="popup__content">',
            '<h4 class="popup__title">' + this.translations.upload_files + '</h4>',
            '<form action="/" class="form form--ajax form--upload">',
              '<div class="form-element form-element--upload">',
                '<div class="dz-message">',
                  '<div class="dz-message-inner">',
                    this.translations.drag_your_files_here,
                    '<span class="dz-submessage">' + this.translations.or_click_here_and_choose_them + '</span>',
                  '</div>',
                '</div>',
              '</div>',
              '<div class="form-actions">',
                '<input type="button" class="button button--action button--cancel" value="' + this.translations.cancel + '" />',
                '<input type="submit" class="button button--submit button--action" value="' + this.translations.upload_files + '" />',
              '</div>',
            '</form>',
          '</div>',
        '</div>',
      ].join('')).appendTo(document.body);

      var
        files_count = 0,
        uploaded = 0,
        files = [];
        drpzn = new Dropzone('.popup--upload-tmp-file .form-element--upload', {
          url: this.ajax_path,
          maxFilesize: 100,
          autoProcessQueue: false,
          parallelUploads: 1,
          maxFiles: 999,
          previewsContainer: '.popup--upload-tmp-file .dz-message',
          addRemoveLinks: true
        });

      drpzn.on('addedfile', function() {
        $('.popup--upload-tmp-file .button--submit').removeClass('button--disabled');
        files_count++;
      });

      drpzn.on('removedfile', function() {
        files_count--;
      });

      drpzn.on('sending', function(file, xhr, formData) {
        formData.append('path', '/files/tmp');
        formData.append('media', '1');
        formData.append('action', 'file-upload');
      }.bind(this));

      drpzn.on('complete', function(file) {
        drpzn.processQueue();
        uploaded++;

        if (file.xhr) {
          var json = $.parseJSON(file.xhr.responseText);

          if (typeof json.error_msg !== 'undefined') {
            window.UI.error('Oops!', json.error_msg);
          }

          if (json.data.path !== '') {
            files.push(json.data.path);
          }
        }

        if (uploaded == files_count) {
          $('.popup--upload-tmp-file .button--submit').removeClass('button--loading').addClass('button--saved');

          setTimeout(function() {
            drpzn.removeAllFiles();

            $('.popup--upload-tmp-file .button--cancel').removeClass('button--disabled');
            $('.popup--upload-tmp-file .button--submit').removeClass('button--loading');
            $('.popup--upload-tmp-file').removeClass('popup--active');

            window.Media.emit('popup:close');

            setTimeout(function () {
              $('.popup--upload-tmp-file .button--submit').removeClass('button--saved');
            }, 500);

            var ext, type, tmp;

            if (this.$activeElement !== null && this.currentCallback !== null) {
              if (uploaded == 1) {
                ext = files[0].split('.');
                ext = (ext.length > 1 && (tmp = ext.pop()) && tmp.indexOf('/') === -1) ? tmp : '';
                type = (ext == '' ? 'folder' : (['jpeg', 'png', 'svg', 'jpg', 'gif'].indexOf(ext.toLowerCase()) !== -1 ? 'image' : 'file'));
                this.currentCallback(files[0], type, this.$activeElement);
              }
              else if (uploaded_total > 1) {
                var $input = this.$activeElement.parents('.form-element').find('>input');

                if ($input.length > 0 && $input.attr('data-multiple') == 'true') {
                  ext = files[0].split('.');
                  ext = (ext.length > 1 && (tmp = ext.pop()) && tmp.indexOf('/') === -1) ? tmp : '';
                  type = (ext == '' ? 'folder' : (['jpeg', 'png', 'svg', 'jpg', 'gif'].indexOf(ext.toLowerCase()) !== -1 ? 'image' : 'file'));

                  this.currentCallback(files.join(','), type, this.$activeElement);
                }
              }
              else {
                this.currentCallback(files[0], type, this.$activeElement);
              }
            }

            files = [];
            files_count = 0;
            uploaded_total = 0;
          }.bind(this), 1000);
        }
      }.bind(this));

      popup.find('.popup__close, .button--cancel').click(function (e) {
        e.preventDefault();
        popup.removeClass('popup--active');
        window.Media.emit('popup:close');
      });

      popup.find('.button--submit').click(function (e) {
        e.preventDefault();

        if (drpzn) {
          drpzn.processQueue();

          $(this).addClass('button--loading');
          $(this).parent().find('.button--cancel').addClass('button--disabled');
        }
      });
    }

    popup.find('.button--submit').addClass('button--disabled');
    popup[0].offsetWidth; // jshint ignore:line
    popup.addClass('popup--active');
    window.Media.emit('popup:open');
  };

  Media.prototype.registerBaseEvents = function() {
    if (typeof Dropzone !== 'undefined') {
      Dropzone.autoDiscover = false;
    }

    this.$dom.find('.dropdown__link--download').unbind('click').bind('click', function (e) {
      e.preventDefault();

      var paths = [];

      this.$dom.find('input[type="checkbox"]:checked').each(function () {
        var $fileItem = $(this).parents('.tile');
        $fileItem.addClass('tile--loading');
        paths.push($fileItem.attr('data-path'));
      });

      if (paths.length > 0) {
        $.ajax({
          type: 'POST',
          dataType: 'json',
          data: {
            media: 1,
            action: 'download',
            path: paths
          },
          url: this.ajax_path,
          success: function (data) {
            if (data.answer && data.path) {
              this.$dom.find('input[type="checkbox"]:checked').each(function (item) {
                $(item).parents('.tile').removeClass('tile--loading');
              }.bind(this));

              window.location.href = data.path;
            }
          }.bind(this)
        });
      }
    }.bind(this));

    this.$dom.find('.dropdown--marked-options').on('click', '.dropdown__link--delete, .dropdown__link--archive, .dropdown__link--unarchive', function (e) {
      e.preventDefault();

      var action = (
            $(event.target).hasClass('dropdown__link--delete') ?
            'delete' :
            ($(event.target).hasClass('dropdown__link--archive') ? 'archive' : 'unarchive')
          ),
          archive = (action == 'archive' ? $(event.target).data('archive') : ''),
          confirm = {
            title: window.Media.translations[action + '_confirm_title'],
            description: window.Media.translations[action +'_confirm_file_desc'],
            callback_ok: function() {
              var paths = [];

              this.$dom.find('input[type="checkbox"]:checked').each(function () {
                var $fileItem = $(this).parents('.tile');
                $fileItem.addClass('tile--loading');
                paths.push($fileItem.attr('data-path'));
              });

              if (paths.length > 0) {
                $.ajax({
                  type: 'POST',
                  dataType: 'json',
                  data: {
                    media: 1,
                    action: action,
                    archive: archive,
                    path: paths
                  },
                  url: this.ajax_path,
                  success: function (data) {
                    if (data.answer) {
                      this.browse(this.past_browse, this.settings);
                    }
                  }.bind(this)
                });
              }
            }.bind(this),
            callback_cancel: function() {

            },
          };

      if (action != 'delete') {
        confirm.button_yes = window.Media.translations[action + '_button_yes'];
      }

      UI.confirm(confirm);
    }.bind(this));

    this.$dom.find('.button--dropdown-trigger').unbind('click').bind('click', function (e) {
      if ($(this).hasClass('button--disabled')) {
        return;
      }

      var $dropdown = $(this).parent().find('.dropdown');

      if ($dropdown.hasClass('dropdown--active')) {
        $dropdown.removeClass('dropdown--active');

        $(document).unbind('click.usernavigation');
      }
      else {
        $dropdown.addClass('dropdown--active');

        $(document).bind('click.usernavigation', function(e) {
          $dropdown.removeClass('dropdown--active');

          $(document).unbind('click.usernavigation');
        });
      }

      return false;
    });

    this.$dom.find('.button--upload').unbind('click').bind('click', function (e) {
      e.preventDefault();

      var $popup = $('.popup--upload-file');

      $popup.find('.button--submit').addClass('button--disabled');

      $popup.appendTo($(document.body));

      $popup[0].offsetWidth; // jshint ignore:line

      $popup.addClass('popup--active');

      window.Media.emit('popup:open');

      $popup.find('.popup__close, .button--cancel').unbind('click').bind('click', function (e) {
        $popup.removeClass('popup--active');
        window.Media.emit('popup:close');
        $('.form-element--folder select', $popup).val('');
        return false;
      });

      $popup.find('.button--submit').unbind('click').bind('click', function () {
        if (window.dropzone) {
          window.dropzone.processQueue();

          $(this).addClass('button--loading');
          $(this).parent().find('.button--cancel').addClass('button--disabled');
        }

        return false;
      });

      $.ajax({
        type: 'POST',
        dataType: 'json',
        data: {
          media: 1,
          action: 'scan',
          path: this.base_path
        },
        url: this.ajax_path,
        success: function (data) {
          var options = '';

          if (data.answer && data.data.length > 0) {
            for (var i = 0, len = data.data.length; i < len; i++) {
              options += '<option value="' + data.data[i] + '"' + (this.base_path + (data.data[i].substr(1) !== '' ? '/' : '') + data.data[i].substr(1) === this.past_browse ? ' selected="selected"' : '') + '>' + data.data[i] + '</option>';
            }
          }

          $popup.find('.form-element--folder select').html(options);

          if (jQuery().select2) {
            $popup.find('.form-element--folder select').select2({
              minimumResultsForSearch: -1
            });
          }
        }.bind(this)
      });
    }.bind(this));

    this.$dom.find('.button--create-folder').unbind('click').bind('click', function (e) {
      e.preventDefault();

      var $popup = $('.popup--create-folder');

      $popup.appendTo($(document.body));

      $popup[0].offsetWidth; // jshint ignore:line

      $popup.addClass('popup--active');

      window.Media.emit('popup:open');

      $popup.find('.popup__close, .button--cancel').unbind('click').bind('click', function (e) {
        $popup.removeClass('popup--active');

        window.Media.emit('popup:close');

        return false;
      });

      $popup.find('.button--submit').unbind('click').bind('click', function (e) {
        e.preventDefault();

        var folderName = $popup.find('.form-element--name .form-element__input').val();

        if (folderName === '') {
          UI.error('Validation error', 'Please enter a folder name in order to create one.');
        }
        else if (folderName.length < 3) {
          UI.error('Validation error', 'Please enter a folder name that is longer than 2 characters.');
        }
        else {
          var folder = $popup.find('.form-element--folder select').val();

          $.ajax({
            type: 'POST',
            dataType: 'json',
            data: {
              media: 1,
              action: 'create-folder',
              path: this.base_path + ((folder === '/' || folder === null) ? '/' + folderName : folder + '/' + folderName)
            },
            url: this.ajax_path,
            success: function (data) {
              this.browse(this.past_browse, this.settings);

              $popup.removeClass('popup--active');

              window.Media.emit('popup:close');
            }.bind(this)
          });
        }
      }.bind(this));

      $.ajax({
        type: 'POST',
        dataType: 'json',
        data: {
          media: 1,
          action: 'scan',
          path: this.base_path
        },
        url: this.ajax_path,
        success: function (data) {
          var options = '';

          if (data.answer && data.data.length > 0) {
            var curent_path_is_archive = this.past_browse.indexOf("\n") !== -1;

            for (var i = 0, len = data.data.length; i < len; i++) {
              options += '<option value="' + data.data[i] + '"' + (this.base_path + (data.data[i].substr(1) !== '' ? '/' : '') + data.data[i].substr(1) === this.past_browse ? ' selected="selected"' : '') + '>' + data.data[i] + '</option>';
            }

            options += '<option value="/' + "\n" + '"' + (curent_path_is_archive ? ' selected="selected"' : '') + '>' + window.Media.translations.archive + '</option>';
          }

          $popup.find('.form-element--folder select').html(options);

          if (jQuery().select2) {
            $popup.find('.form-element--folder select').select2({
              minimumResultsForSearch: -1
            });
          }
        }.bind(this)
      });
    }.bind(this));

    if (typeof window.dropzone !== 'undefined') {
      window.dropzone.destroy();
    }

    window.dropzone = new Dropzone('.popup--upload-file .form-element--upload', {
      url: this.ajax_path,
      maxFilesize: 100,
      autoProcessQueue: false,
      parallelUploads: 1,
      maxFiles: 999,
      previewsContainer: '.popup--upload-file .dz-message',
      addRemoveLinks: true
    });

    window.dropzone.on('addedfile', function() {
      $('.popup--upload-file .button--submit').removeClass('button--disabled');

      window.totalFilesCount++;
      window.dropzoneErrors = 0;
    });

    window.dropzone.on('removedfile', function() {
      window.totalFilesCount--;
    });

    window.dropzone.on('sending', function(file, xhr, formData) {
      folder = $('.popup--upload-file .form-element--folder select').val();

      formData.append('path', this.base_path + (folder !== null ? folder : ''));
      formData.append('media', '1');
      formData.append('action', 'file-upload');
    }.bind(this));

    window.dropzone.on('complete', function(file) {
      window.dropzone.processQueue();
      window.totalUploadedFiles++;

      if (file.xhr) {
        var json = $.parseJSON(file.xhr.responseText);

        if (typeof json.error_msg !== 'undefined') {
          window.UI.error('Oops!', json.error_msg);
          window.dropzoneErrors++;
        }
        else if (json.data.path !== '') {
          window.totalFiles.push({
            path: json.data.path
          });
        }
      }

      if (window.totalUploadedFiles == window.totalFilesCount) {
        $('.popup--upload-file .button--submit').removeClass('button--loading').addClass('button--saved');

        setTimeout(function() {
          window.dropzone.removeAllFiles();

          $('.popup--upload-file .button--cancel').removeClass('button--disabled');
          $('.popup--upload-file .button--submit').removeClass('button--loading');

          $('.popup--upload-file').removeClass('popup--active');

          if (window.dropzoneErrors == 0) {
            this.$dom.removeClass('popup--active');
          }

          window.Media.emit('popup:close');

          setTimeout(function () {
            $('.popup--upload-file .button--submit').removeClass('button--saved');
          }, 500);

          var ext, type,
              is_popup = this.$activeElement !== null;

          if (this.currentCallback !== null && window.totalFiles.length) {
            if (window.totalUploadedFiles == 1) {
              ext = window.totalFiles[0].path.split('/');
              ext = ext[(ext.length - 1)];
              ext = ext.split('.');
              ext = ext[(ext.length - 1)].toLowerCase();

              type = (ext === '' ? 'folder' : (['jpeg', 'png', 'svg', 'jpg', 'gif'].indexOf(ext) !== -1 ? 'image' : 'file'));

              this.currentCallback(window.totalFiles[0].path, type, this.$activeElement);
            }
            else if (is_popup) {
              var $input = this.$activeElement.parents('.form-element').find('input');

              if ($input.length > 0 && $input.attr('data-multiple') == 'true') {
                ext = window.totalFiles[0].path.split('/');
                ext = ext[(ext.length - 1)];
                ext = ext.split('.');
                ext = ext[(ext.length - 1)].toLowerCase();

                type = (ext === '' ? 'folder' : (['jpeg', 'png', 'svg', 'jpg', 'gif'].indexOf(ext) !== -1 ? 'image' : 'file'));

                this.currentCallback(window.totalFiles.map(function (file) {
                  return file.path;
                }).join(','), type, this.$activeElement);
              }
            }
          }

          if (!is_popup || window.totalUploadedFiles != 1) {
            this.browse(this.past_browse, this.settings);
          }

          window.totalFiles = [];
          window.totalFilesCount = 0;
          window.totalUploadedFiles = 0;
          window.dropzoneErrors = 0;
        }.bind(this), 1000);
      }
    }.bind(this));
  };

  Media.prototype.enableItemOptions = function(enable) {
    if (enable) {
      this.$dom.find('#select-actions').removeClass('disabled');
    }
    else {
      var ch = false;

      this.$dom.find('.thumb').each(function() {
        if ($(this).hasClass('checked')) {
          ch = true;
        }
      });

      if (!ch) {
        this.$dom.find('#select-actions').addClass('disabled');
      }
    }
  };

  Media.prototype.selectItem = function(path, type) {
    if (!this.$container) {
      this.$dom.removeClass('popup--active');
      window.Media.emit('popup:close');
    }

    this.currentCallback(path, type, this.$activeElement);
  };

  Media.prototype.cropUpdate = function (x, y, w, h) {
    $('.crop--val-x').html('<strong>x</strong>&nbsp;' + x);
    $('.crop--val-y').html('<strong>y</strong>&nbsp;' + y);
    $('.crop--val-w').html('<strong>' + window.Media.translations.crop_dimentions_width + '</strong>&nbsp;' + w);
    $('.crop--val-h').html('<strong>' + window.Media.translations.crop_dimentions_height + '</strong>&nbsp;' + h);
  };

  Media.prototype.applyCropOptions = function () {
    if (this.crop_options.size && this.crop_options.size.enabled) {
      this.croppr.options.aspectRatio = this.crop_options.size.h / this.crop_options.size.w;
      $('.crop--val-size-h,.crop--val-size-w').removeAttr('disabled');
      $('.crop--val-w,.crop--val-h').hide();
    }
    else {
      this.croppr.options.aspectRatio = null;
      $('.crop--val-size-h,.crop--val-size-w').attr('disabled', 'disabled');
      $('.crop--val-w,.crop--val-h').show();
    }

    this.croppr.reset();
  };

  Media.prototype.crop = function (path, options) {
    this.crop_options = options || {};

    console.log(this.crop_options);

    if (this.croppr !== null) {
      this.croppr.destroy();
      this.croppr = null;
    }

    this.getTranslations(function () {
      var
        $popup = $('.popup--crop'),
        $image = $('<img src="" alt="" class="popup__image" />');

      $('.crop--val-size-h,.crop--val-size-w').attr('disabled', 'disabled').val(100);
      $('.crop--val-w,.crop--val-h').show();

      if ($popup.find('#crop-size-checkbox').is(':checked')) {
        $popup.find('#crop-size-checkbox').unbind('click');
        $popup.find('#crop-size-checkbox').click();
      }

      $popup.find('.media-crop-image').html($image);

      $image.bind('load', function() {
        $image.unbind('load');
        $popup.appendTo($(document.body));
        $popup[0].offsetWidth; // jshint ignore:line
        $popup.addClass('popup--active');
        window.Media.emit('popup:open');

        this.croppr = new Croppr($('.popup--crop .popup__image')[0], {
          startSize: [100, 100, '%'],
          onInitialize: function(instance) {
            setTimeout(function () {
              var value = instance.getValue();
              this.cropUpdate(Math.round(value.x), Math.round(value.y), Math.round(value.width), Math.round(value.height));
              this.applyCropOptions();
            }.bind(this), 500);
          }.bind(this),
          onCropMove: function (value) {
            this.cropUpdate(Math.round(value.x), Math.round(value.y), Math.round(value.width), Math.round(value.height));
          }.bind(this)
        });

        $popup.find('#crop-size-checkbox').unbind('click').bind('click', function () {
          if ($popup.find('#crop-size-checkbox').is(':checked')) {
            this.crop_options.size = this.crop_options.size || { w: 100, h: 100 };
            this.crop_options.size.enabled = true;
          }
          else {
            this.crop_options.size.enabled = false;
          }

          this.applyCropOptions();
        }.bind(this));

        $('.crop--val-size-w, .crop--val-size-h').unbind('keydown keypress keyup').bind('keydown keypress keyup', function () {
          this.crop_options.size.w = parseInt($('.crop--val-size-w').val(), 10);
          this.crop_options.size.h = parseInt($('.crop--val-size-h').val(), 10);

          this.applyCropOptions();
        }.bind(this));

        $popup.find('.popup__close').unbind('click').bind('click', function () {
          $popup.removeClass('popup--active');
          window.Media.emit('popup:close');
          return false;
        });

        $popup.find('.button--crop-save').unbind('click').bind('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();

          UI.confirm({
            title: window.Media.translations.crop_confirm_title,
            description: window.Media.translations.crop_confirm_desc,
            button_yes: window.Media.translations.crop_it,
            callback_ok: function() {
              $.ajax({
                type: 'POST',
                dataType: 'json',
                data: {
                  media: 1,
                  action: 'crop',
                  path: path,
                  options: this.croppr.getValue(),
                  size: this.crop_options.size
                },
                url: this.ajax_path,
                success: function (data) {
                  if (typeof data.error !== 'undefined') {
                    window.UI.error(data.error.title, data.error.description);
                    return;
                  }


                  $popup.removeClass('popup--active');
                  window.Media.emit('popup:close');

                  if (this.crop_options.refresh_browse) {
                    this.browse(this.past_browse, this.settings);
                  }
                }.bind(this)
              });
            }.bind(this),
            callback_cancel: function() {},
          });
        }.bind(this));
      }.bind(this));

      $image.attr('src', path);
    }.bind(this), {

    });
  };

  Media.prototype.registerRenderEvents = function() {
    this.$dom.find('.tile__tool--preview').unbind('click').bind('click', this, function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();

      var $popup = $('.popup--preview');
      var $img_wrapper = $popup.find('.popup__image-wrapper');
      var $image = $('<img src="" alt="" class="popup__image" />');

      $popup.find('.popup__title').html();

      $img_wrapper.html('').append($image).append('<span class="caption"><span class="caption__title">' + $(this).attr('data-title') + '</span><span class="caption__description">' + window.Media.translations.path + ': ' + $(this).attr('data-caption') + '</span></span>');

      $image.bind('load', function() {
        $(this).unbind('load');
        $popup.appendTo($(document.body));
        $popup[0].offsetWidth; // jshint ignore:line
        $popup.addClass('popup--active');
        window.Media.emit('popup:open');

        $popup.find('.popup__close').unbind('click').bind('click', function (e) {
          $popup.removeClass('popup--active');
          window.Media.emit('popup:close');
          return false;
        });
      });

      $image.attr('src', $(this).attr('href'));
    });

    this.$dom.find('.tile__tool--crop').unbind('click').bind('click', function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();

      scope.Media.crop($(this).attr('data-path'), {
        refresh_browse: true
      });
    });

    this.$dom.find('.tile__tool--copy').unbind('click').bind('click', this, function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();

      var $fileItem = $(this).parents('.tile');

      e.data.copyText($fileItem.attr('data-path'));
    });

    this.$dom.find('.tile__tool--download').unbind('click').bind('click', this, function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();

      var $fileItem = $(this).parents('.tile');

      $fileItem.addClass('tile--loading');

      $.ajax({
        type: 'POST',
        dataType: 'json',
        data: {
          media: 1,
          action: 'download',
          path: $fileItem.attr('data-path')
        },
        url: e.data.ajax_path,
        success: function (data) {
          if (data.answer && data.path) {
            $fileItem.removeClass('loading');

            window.location.href = data.path;
          }
        }
      });
    });

    this.$dom.find('.tile__tool--delete').unbind('click').bind('click', this, function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();

      UI.confirm({
        title: window.Media.translations.delete_confirm_title,
        description: ($(this).parents('.tile--type-folder').length > 0 ? window.Media.translations.delete_confirm_folder_desc : window.Media.translations.delete_confirm_file_desc),
        callback_ok: function() {
          var $fileItem = $(this).parents('.tile');

          $fileItem.addClass('tile--loading');

          $.ajax({
            type: 'POST',
            dataType: 'json',
            data: {
              media: 1,
              action: 'delete',
              path: $fileItem.attr('data-path')
            },
            url: e.data.ajax_path,
            success: function (data) {
              this.browse(this.past_browse, this.settings);
            }.bind(e.data)
          });
        }.bind(this),
        callback_cancel: function() {

        },
      });
    });

    this.$dom.find('.tile__tool--lock, .tile__tool--unlock').unbind('click').bind('click', this, function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();

      var is_lock = $(this).hasClass('tile__tool--lock');

      UI.confirm({
        title: window.Media.translations.lock_confirm_title,
        description: is_lock ? window.Media.translations.lock_confirm_folder_desc : window.Media.translations.unlock_confirm_folder_desc,
        button_yes: is_lock ? window.Media.translations.lock_it : window.Media.translations.unlock_it,
        callback_ok: function() {
          var $fileItem = $(this).parents('.tile');

          $fileItem.addClass('tile--loading');

          $.ajax({
            type: 'POST',
            dataType: 'json',
            data: {
              media: 1,
              action: (is_lock ? 'lock_folder' : 'unlock_folder'),
              path: $fileItem.attr('data-path')
            },
            url: e.data.ajax_path,
            success: function (data) {
              this.browse(this.past_browse, this.settings);
            }.bind(e.data)
          });
        }.bind(this),
        callback_cancel: function() {

        },
      });
    });

    this.$dom.find('.tile--back').unbind('click').bind('click', this, function (e) {
      e.preventDefault();

      var	$this = $(this);
      var	path = $this.attr('data-path');
      var	pathArr = path.split('/');

      pathArr.splice(-1, 1);

      e.data.last_browse = pathArr.join('/');

      if (path == e.data.base_path) {
        e.data.last_browse = false;
      }

      e.data.browse(path, e.data.settings);
    });

    this.$dom.find('.tile--type-folder').unbind('click').bind('click', this, function (e) {
      if (
        (e.target.classList.contains('tile__tools') || e.target.classList.contains('tile__title')) &&
        e.data.currentSettings.type === 'folder'
      ) {
        if (e.data.currentCallback) {
          e.data.selectItem($(this).attr('data-path'), 'file');
        }
        else {
          $(this).find('.checkbox input').trigger('click');
        }
      }
      else {
        e.data.last_browse = e.data.past_browse;
        e.data.browse($(this).attr('data-path'), e.data.settings);
      }
    });

    this.$dom.find('.tile--type-image').unbind('click').bind('click', this, function (e) {
      if (e.data.currentCallback) {
        e.data.selectItem($(this).attr('data-path'), 'image');
      }
      else {
        $(this).find('.checkbox input').trigger('click');
      }
    });

    this.$dom.find('.tile--type-file').unbind('click').bind('click', this, function (e) {
      if (e.data.currentCallback) {
        e.data.selectItem($(this).attr('data-path'), 'file');
      }
      else {
        $(this).find('.checkbox input').trigger('click');
      }
    });

    this.$dom.find('.tile .checkbox').click(function(e){
      e.stopPropagation();
      $('input', $(this)).trigger('click');
    });

    this.$dom.find('.tile .checkbox input').unbind('change').bind('change', this, function (e) {
      this.detectCheckedItems();
    }.bind(this));
  };

  Media.prototype.detectCheckedItems = function() {
    if (this.$dom.find('.tile .checkbox input:checked').length > 0) {
      var el = this.$dom.find('.button--dropdown-action'),
          el_ul = el.next();

      el_ul.find('.dropdown__link--unarchive').hide();

      if (el.hasClass('button--disabled')) {
        el.removeClass('button--disabled');

        if (this.past_browse.slice(-1) == "\n") {
          el_ul.find('.dropdown__link--download').hide();
        }
        else {
          el_ul.find('.dropdown__link--download').show();
        }

        this.archive_refresh();
      }

      if (this.past_browse.split("\n" + '/').length == 2) {
        el_ul.find('.dropdown__link--unarchive').show();
      }
    }
    else {
      this.$dom.find('.button--dropdown-trigger').addClass('button--disabled');
    }
  };

  Media.prototype.setPaths = function(paths) {
    this.base_path = paths.root;

    if (paths.api) {
      this.ajax_path = paths.api;
    }
  };

  Media.prototype.fetch = function(path, settings, fn) {
    if (this.ajax !== null) {
      this.ajax.abort();
      this.ajax = null;
    }

    this.$ajax = $.ajax({
      type: 'POST',
      dataType: 'json',
      data: {
        media: 1,
        action: 'glob',
        path: path,
        settings: settings
      },
      url: this.ajax_path,
      success: function (data) {
        fn(data);
        this.ajax = null;
        this.detectCheckedItems();

        if (data.is_archive) {
          this.$dom.find('.button--upload').addClass('button--disabled');
        }
        else {
          this.$dom.find('.button--upload').removeClass('button--disabled');
        }

        if (data.is_archive && path.slice(-1) !== "\n") {
          this.$dom.find('.button--create-folder').addClass('button--disabled');
        }
        else {
          this.$dom.find('.button--create-folder').removeClass('button--disabled');
        }
      }.bind(this)
    });
  };

  Media.prototype.render = function(settings, data) {
    var output = '';

    if (this.last_browse) {
      output += [
      '<div class="tile tile--back" data-type="folder" data-path="' + this.last_browse + '" data-name="Back" data-realname="back">',
        '<i class="tile__icon fa fa-arrow-circle-left"></i>',
      '</div>'
      ].join('');
    }

    if (data.answer) {
      if (data.view && data.view.length > 0) {
        var item;

        for (var i = 0, len = data.view.length; i < len; i++) {
          item = data.view[i];

          var
            ext = item.name.split('.'),
            type = '';

          switch (item.type) {
            case 1:
              type = 'folder';
              break;

            case 2:
              type = 'image';
              break;

            case 3:
              type = 'file';
              break;
          }

          var is_archive = item.path.slice(-1) == "\n";

          output += [
            '<div class="tile tile--type-' + type + (item.type == 1 && item.locked && !item.unlock_access ? '-no-access' : '') + '" data-path="' + item.path + '">',
            (item.type === 1 ? (item.locked ? '<i class="tile__icon fa fa-lock"></i>' : '<i class="tile__icon fa fa-folder"></i>') : ''),
            (item.type === 2 ? '<div class="tile__image" style="background-image: url(' + item.path + ');"></div>' : ''),
            (item.type === 3 ? '<i class="tile__icon fa fa-file"></i>' : ''),
            '<span class="tile__title"><span class="tile__title-inner">' + item.name + '</span></span>',
            ((!item.locked || item.unlock_access) ? '<div class="tile__tools">' : ''),
            (item.type == 2 ? '<a href="' + item.path + '" data-title="' + item.name + '" data-caption="' + item.path + '" class="tile__tool tile__tool--preview"><i class="tile__tool-icon fa fa-eye"></i><span class="tooltip">' + this.translations.example + '</span></a></li>' : ''),
            (item.type == 2 ? '<a href="' + item.path + '" data-title="' + item.name + '" data-path="' + item.path + '" class="tile__tool tile__tool--crop"><i class="tile__tool-icon fa fa-crop"></i><span class="tooltip">' + this.translations.crop + '</span></a></li>' : ''),
            (item.type !== 1 ? '<a href="#" class="tile__tool tile__tool--copy"><i class="tile__tool-icon fa fa-clipboard"></i><span class="tooltip">' + this.translations.copy_to_clipboard + '</span></a></li>' : ''),
            (item.type !== 1 ? '<a href="#" class="tile__tool tile__tool--download"><i class="tile__tool-icon fa fa-download"></i><span class="tooltip">' + this.translations.download + '</span></a></li>' : ''),
            ((item.type === 1 && (!item.locked || item.unlock_access)) ? '<a href="#" class="tile__tool tile__tool--open"><i class="tile__tool-icon fa fa-arrow-right"></i><span class="tooltip">' + this.translations.open_folder + '</span></a></li>' : ''),
            ((item.locked && item.unlock_access) ? '<a href="#" class="tile__tool tile__tool--unlock"><i class="tile__tool-icon fa fa-unlock"></i><span class="tooltip">' + this.translations.unlock_folder + '</span></a></li>' : ''),
            ((!item.locked && item.lock_access) ? '<a href="#" class="tile__tool tile__tool--lock"><i class="tile__tool-icon fa fa-lock"></i><span class="tooltip">' + this.translations.lock_folder + '</span></a></li>' : ''),
            ((!item.locked && !is_archive) ? '<a href="#" class="tile__tool tile__tool--delete"><i class="tile__tool-icon fa fa-trash-o"></i><span class="tooltip">' + this.translations.delete + '</span></a></li>' : ''),
            ((!item.locked || item.unlock_access) ? '</div>' : ''),
            (!is_archive ? '<div class="checkbox checkbox--tile"><input class="item-choosen" type="checkbox" id="check-files-' + i + '" value="1" /><label></label></div>' : ''),
            '</div>',
          ].join('');
        }
      }
    }

    if (output.length === 0) {
      this.$dom.find('.medialibrary__message').addClass('medialibrary__message--active');
    }
    else {
      this.$dom.find('.medialibrary__message').removeClass('medialibrary__message--active');
    }

    this.$dom.find('.medialibrary__list').html(output);

    this.settings = settings;

    this.registerRenderEvents();
  };

  Media.prototype.copyText = function(text){
    function selectElementText(element) {
      var range;

    if (document.selection) {
      range = document.body.createTextRange();
      range.moveToElementText(element);
      range.select();
    } else if (window.getSelection) {
      range = document.createRange();
      range.selectNode(element);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    }
    }
    var element = document.createElement('DIV');
    element.textContent = text;
    document.body.appendChild(element);
    selectElementText(element);
    document.execCommand('copy');
    element.remove();
  };

  Media.prototype.browse = function(path, settings, useMediaApiIfPossible) {
    if (typeof useMediaApiIfPossible === 'undefined') {
      useMediaApiIfPossible = false;
    }

    if (this.translations === null) {
      this.getTranslations(function () {
        this.browse(path, settings, useMediaApiIfPossible);
      }.bind(this));
      return;
    }

    if (useMediaApiIfPossible === true && this.inIframe()) {
      if (typeof window.top.mediaApiService !== 'undefined') {
        window.top.mediaApiService.browse(function (path, type) {
          this(path, type);
        }.bind(settings.callback));

        return;
      }
    }

    settings = settings || {};
    settings.type = settings.type || 'file';
    settings.extensions = settings.extensions || [];
    settings.callback = settings.callback || null;

    this.currentSettings = settings;

    if (settings.callback !== null) {
      this.currentCallback = settings.callback;
    }

    if (settings.tmp_file && !this.$container) {
      this.build_tmp_upload();
    }
    else {
      if (this.$dom === null) {
        this.build();
      }

      setTimeout(function() {
        if (!this.$container) {
          this.$dom.appendTo($(document.body));

          this.$dom[0].offsetWidth; // jshint ignore:line

          this.$dom.addClass('popup--active');

          window.Media.emit('popup:open');
        }
      }.bind(this), 10);

      this.fetch(path, settings, function (data) {
        this.render(settings, data);
      }.bind(this));
    }

    this.past_browse = path;
  };

  Croppr.prototype.parseElementValues = function(element) {
    var value = element.val();

    if (!element.is('select')) {
      if (!isNumber(value)) {
        if (value !== '') {
          element.addClass('is-danger');
        }

        return null;
      }
      else {
        element.removeClass('is-danger');
        return value;
      }
    }
    else {
      return value;
    }
  };

  Croppr.prototype.handleChange = function(option, elements, ratio) {
    var values = elements.map(this.parseElementValues),
        in_percents = values[2] === '%';

    this.options[option] = {
      width: Math.round(in_percents ? values[0] : values[0]/ratio),
      height: Math.round(in_percents ? values[1] : values[1]/ratio),
      unit: values[2]
    };

    if (values[2] === '%') {
      this.options.convertToPixels(this.cropperEl);
    }

    this.reset();
  };

  scope.Media = new Media();

  if (typeof window.UI === 'undefined') {
    $(document).ready(function () {
      scope.Media.reload();
    });
  }
})(window, jQuery);
